/**
 * Où l'on se trouve, et ce que cet environnement permet.
 *
 * L'Atelier ne fonctionne que sur un poste de développement : il écrit dans le
 * code du produit et fait tourner un modèle d'IA local. C'était vrai depuis
 * toujours, et personne ne l'apprenait avant d'avoir cliqué sur une entrée de
 * navigation qui avait l'air parfaitement normale.
 *
 * Ce hook répond à la question AVANT le clic. Il ne rend rien exécutable de
 * plus : il rend une contrainte visible.
 *
 * Le défaut est PRUDENT — `atelier_disponible: false` tant qu'on ne sait pas.
 * Promettre une fabrique qui refusera est pire que la présenter comme
 * indisponible une seconde de trop.
 */
import { useEffect, useState } from "react";

import { apiCall } from "../lib/adminApi";

let cache = null;

export const useContexteAdmin = () => {
  const [contexte, setContexte] = useState(
    cache || { atelier_disponible: false, environnement: null, pourquoi: null }
  );

  useEffect(() => {
    if (cache) return;
    let vivant = true;
    apiCall("/api/admin/vue/contexte").then((r) => {
      if (!vivant || !r.success) return;
      cache = r.data;
      setContexte(r.data);
    });
    return () => { vivant = false; };
  }, []);

  return {
    ...contexte,
    // `null` tant que la réponse n'est pas là : l'interface peut alors ne rien
    // affirmer, plutôt que d'afficher un avertissement qui clignote.
    connu: contexte.environnement !== null,
  };
};

export default useContexteAdmin;
